import moment from 'moment'
import {WizClassifySelect} from '@/containers/common';
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      title: "课程名称",
      name: "name",
      dataIndex: "name",
      tableItem: {
        width: 200
      },
      searchItem: {
      },
    },
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "课程编码",
      name: "scoId",
      dataIndex: "scoId",
      tableItem: {
        width: 220
      },
      searchItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryIds",
      dataIndex: "programCategoryIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          checkable: true,
          itemProps: {
            icon: 'unordered-list',
            title: '课程分类',
            tips: '请勾选所属课程分类'
          },
          treeProps: {checkStrictly: true}
        },
        apiProps: {type: 1},
        selectProps: {
          placeholder: '请选择课程分类'
        },
      },
    },
    {
      title: "课程分类",
      name: "programCategoryNames",
      dataIndex: "programCategoryNames",
      tableItem: {
        width: 220
      }
    },
    // {
    //   title: "截止时间",
    //   name: "endDate",
    //   dataIndex: "endDate",
    //   tableItem: {
    //     width: 220
    //   },
    // },
    {
      title: "课程时间",
      name: "programDate",
      dataIndex: "programDate",
      tableItem: {
        width: 300,
        render: (text, record) => {
          const { startDate, endDate } = record;
          const programDate = formatterDate(startDate) + " ~" + formatterDate(endDate);
          return programDate
        }
      },
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD'
      },
    }

  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'program/getListByPage',
    ...api
  }
}

const program = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['programDate'] && value['programDate'].length === 2) {
          value['startDate'] = moment(value['programDate'][0]).format("YYYY-MM-DD HH:mm:00")
          value['endDate'] = moment(value['programDate'][1]).format("YYYY-MM-DD HH:mm:59")
        }
        delete value['programDate']

        return value
      }
    },
  }
}

export default program
